/* eslint-disable no-console */
import axios from "axios";
import { acquireToken } from "../auth/authUtils";

const baseUrl = process.env.REACT_APP_BASE_URL;
const endpoint = "user";

export const getUser = async () => {
  try {
    const accessToken = await acquireToken();
    const response = await axios.get(`${baseUrl}/${endpoint}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const createUser = async (region) => {
  try {
    const accessToken = await acquireToken();
    const response = await axios.post(
      `${baseUrl}/${endpoint}`,
      { region },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Create user API call failed:", error);
    if (error?.response?.data) {
      throw error.response.data;
    }
    throw error;
  }
};

export const updateUser = async (region) => {
  try {
    const accessToken = await acquireToken();
    const response = await axios.patch(
      `${baseUrl}/${endpoint}`,
      { region },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Update user API call failed:", error);
    if (error?.response?.data) {
      throw error.response.data;
    }
    throw error;
  }
};
